import { Layout } from "./layout";
import Home from "./views/home";

const App = () => {
  return (
    <Layout>
      <Home />
    </Layout>
  );
};

export default App;
